export default __webpack_public_path__ + "pgnv-assets/1de9caeeb4538ce074a368741ed9e4b7.png";